var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": _vm.tier == 0 ? 500 : 650 } },
    [
      _vm.tier == 0
        ? _c("app-tier0", {
            on: {
              "show-demo": function ($event) {
                _vm.toggleDemoShedule = true
              },
            },
          })
        : _vm._e(),
      _vm.tier == 1
        ? _c("app-tier1", {
            on: {
              "show-demo": function ($event) {
                _vm.toggleDemoShedule = true
              },
            },
          })
        : _vm._e(),
      _vm.tier == 2
        ? _c("app-tier2", {
            on: {
              "show-demo": function ($event) {
                _vm.toggleDemoShedule = true
              },
            },
          })
        : _vm._e(),
      _c("w-card-actions", [
        _c(
          "div",
          { staticClass: "actions-info-box" },
          [
            _c(
              "w-button",
              { staticClass: "cancel", on: { click: _vm.close } },
              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
            ),
            _c("w-spacer"),
            _c(
              "w-button",
              {
                attrs: { to: "/account/activate?tier=" + _vm.tier },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.upgrade-now")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.toggleDemoShedule,
            callback: function ($$v) {
              _vm.toggleDemoShedule = $$v
            },
            expression: "toggleDemoShedule",
          },
        },
        [
          _c("app-demo-shedule", {
            on: {
              cancel: function ($event) {
                _vm.toggleDemoShedule = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }